import { render, staticRenderFns } from "./Hypnobirthing.vue?vue&type=template&id=162fc38c&"
import script from "./Hypnobirthing.vue?vue&type=script&lang=js&"
export * from "./Hypnobirthing.vue?vue&type=script&lang=js&"
import style0 from "./Hypnobirthing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports